import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { APP_NAME } from "../utils/constant";

export default function footer() {
  return (
    <>
      <footer className="footer">
        <div className="container-fluid d-flex justify-content-center align-items-center h-100">
          <div className="text-center fw-bold w-100">
            © Copyright - <span className="notranslate" translate="no">{APP_NAME}</span>. All Right Reserved
          </div>
        </div>
      </footer>
    </>
  );
}
